// extracted by mini-css-extract-plugin
export default {"input":"viewPlans_input__SZYO8","removePrice":"viewPlans_removePrice__c6Tid","settingBtn":"viewPlans_settingBtn__RrWP3"};